/**
 * Bracelet Designer — main UI (ASTRIS-style)
 */
(function () {
  const Core = window.BraceletCore;
  if (!Core) return;

  const root = document.getElementById('bracelet-designer-root');
  if (!root) return;

  const cfg = Core.CONFIG();
  const categories = cfg.categories || [];
  const IN_USE_CATEGORY = 'in_use';
  const WRIST_MIN_CM = 13;
  const WRIST_MAX_CM = 25;
  const WRIST_DEFAULT_CM = 15;

  let beads = [];
  let wristSizeCm = WRIST_DEFAULT_CM;
  let activeCategory = 'all';
  let searchQuery = '';
  let zoom = 1;
  let canvas;

  const MOBILE_PICKER_MQ = window.matchMedia('(max-width: 1023px)');

  const PREPARING_TIPS = [
    {
      title: 'Choose your crystals',
      body: 'Browse categories and tap a bead to add it to your bracelet circle.',
    },
    {
      title: 'Watch your FIT',
      body: 'Keep FIT at or below 100% so the bracelet matches your wrist size.',
    },
    {
      title: 'Need at least 12 beads',
      body: 'Add enough beads to unlock Confirm Design and checkout.',
    },
  ];

  const PREP_MIN_MS = 200;
  const PREP_THUMB_MAX_MS = 3000;
  const PREP_CONCURRENCY = 10;

  const els = {
    title: root.querySelector('[data-bd-title]'),
    titleEdit: root.querySelector('[data-bd-title-edit]'),
    canvas: root.querySelector('[data-bd-canvas]'),
    fit: root.querySelector('[data-bd-fit]'),
    total: root.querySelector('[data-bd-total]'),
    zoomLabel: root.querySelector('[data-bd-zoom]'),
    categories: root.querySelector('[data-bd-categories]'),
    grid: root.querySelector('[data-bd-grid]'),
    search: root.querySelector('[data-bd-search]'),
    addCart: root.querySelector('[data-bd-tools-open]'),
    buyNow: root.querySelector('[data-bd-confirm-design]'),
    confirmLabel: root.querySelector('[data-bd-confirm-label]'),
    toolsSheet: document.querySelector('[data-bd-tools-sheet]'),
    clear: root.querySelector('[data-bd-clear]'),
    toast: document.querySelector('[data-bd-toast]'),
    toastIcon: document.querySelector('[data-bd-toast-icon]'),
    toastText: document.querySelector('[data-bd-toast-text]'),
    picker: root.querySelector('[data-bd-picker]'),
    pickerBackdrop: root.querySelector('[data-bd-picker-backdrop]'),
    pickerOpenButtons: root.querySelectorAll('[data-bd-picker-open]'),
    pickerClose: root.querySelector('[data-bd-picker-close]'),
    pickerResize: root.querySelector('[data-bd-picker-resize]'),
    main: root.querySelector('.bd-main'),
    inspire: root.querySelector('[data-bd-inspire]'),
    save: root.querySelector('[data-bd-save]'),
    saveLabel: root.querySelector('[data-bd-save-label]'),
    saveSpinner: root.querySelector('[data-bd-save-spinner]'),
    canvasWrap: root.querySelector('[data-bd-canvas-wrap]'),
    canvasPanel: root.querySelector('.bd-canvas-panel'),
    codeImportOpen: root.querySelector('[data-bd-code-import-open]'),
    codeCopyBtn: root.querySelector('[data-bd-code-copy]'),
  };

  const toolsSheetEls = els.toolsSheet
    ? {
        root: els.toolsSheet,
        backdrop: els.toolsSheet.querySelector('[data-bd-tools-close]'),
        inspireBtn: els.toolsSheet.querySelector('[data-bd-tools-inspire]'),
        importBtn: els.toolsSheet.querySelector('[data-bd-tools-import]'),
        shareBtn: els.toolsSheet.querySelector('[data-bd-tools-share]'),
      }
    : null;

  const codeImportRoot = document.querySelector('[data-bd-code-import]');
  const codeImportEls = codeImportRoot
    ? {
        root: codeImportRoot,
        backdrop: codeImportRoot.querySelector('[data-bd-code-import-backdrop]'),
        input: codeImportRoot.querySelector('[data-bd-code-import-input]'),
        cancel: codeImportRoot.querySelector('[data-bd-code-import-cancel]'),
        confirm: codeImportRoot.querySelector('[data-bd-code-import-confirm]'),
        title: codeImportRoot.querySelector('[data-bd-code-import-title]'),
        hint: codeImportRoot.querySelector('[data-bd-code-import-hint]'),
      }
    : null;

  const i18n = {
    codeImport: root.dataset.i18nCodeImport || 'Import',
    codeCopy: root.dataset.i18nCodeCopy || 'Copy',
    codeModalTitle: root.dataset.i18nCodeModalTitle || 'Import design',
    codeModalHint:
      root.dataset.i18nCodeModalHint || 'Paste a design code shared with you, then confirm to load the bracelet.',
    codeModalConfirm: root.dataset.i18nCodeModalConfirm || 'Import',
    codeModalCancel: root.dataset.i18nCodeModalCancel || 'Cancel',
    codeCopied: root.dataset.i18nCodeCopied || 'Design code copied',
    codeCopyEmpty: root.dataset.i18nCodeCopyEmpty || 'Add beads before copying a design code',
    codeInvalid: root.dataset.i18nCodeInvalid || 'Invalid design code',
    codeImported: root.dataset.i18nCodeImported || 'Design imported',
    codeReplaceTitle: root.dataset.i18nCodeReplaceTitle || 'Replace current design?',
    codeReplaceMessage:
      root.dataset.i18nCodeReplaceMessage || 'Importing a design code will replace your current bracelet.',
    codeReplaceConfirm: root.dataset.i18nCodeReplaceConfirm || 'Import',
    tools: root.dataset.i18nTools || 'Tools',
    inspire: root.dataset.i18nInspire || 'Inspire',
    importDesign: root.dataset.i18nImportDesign || 'Import Design',
    shareDesign: root.dataset.i18nShareDesign || 'Share Design',
    shareModalTitle: root.dataset.i18nShareModalTitle || 'Share design',
    shareModalHint:
      root.dataset.i18nShareModalHint ||
      'Send the code below to a friend. They can tap Import Design on the design page to copy your bracelet.',
    shareModalCopy: root.dataset.i18nShareModalCopy || 'Copy code',
    shareModalCopied: root.dataset.i18nShareModalCopied || 'Code copied',
    shareModalNote:
      root.dataset.i18nShareModalNote || 'The code starts with CHDIY. Do not change any characters.',
    shareModalGenerating: root.dataset.i18nShareModalGenerating || 'Generating share code…',
    shareModalClose: root.dataset.i18nShareModalClose || 'Close',
    shareModalError: root.dataset.i18nShareModalError || 'Could not create share code',
    confirmDesign: root.dataset.i18nConfirmDesign || 'Confirm Design',
    selectBeads: root.dataset.i18nSelectBeads || 'Select Beads',
    categoryInUse: root.dataset.i18nCategoryInUse || 'In Use',
    save: root.dataset.i18nSave || 'Save',
    saveSaving: root.dataset.i18nSaveSaving || 'Saving…',
    saveEmpty: root.dataset.i18nSaveEmpty || 'Add at least one bead before saving',
    saveSuccess: root.dataset.i18nSaveSuccess || 'Design saved to My Designs',
    saveError: root.dataset.i18nSaveError || 'Could not save design',
    saveLoginRequired: root.dataset.i18nSaveLoginRequired || 'Sign in to save designs to your account',
    saveLogin: root.dataset.i18nSaveLogin || 'Sign in to save',
    saveLocalFallback:
      root.dataset.i18nSaveLocalFallback ||
      'Saved on this device. Cloud API is not ready yet — configure App Proxy to sync to your account.',
  };

  let inUseCategoryVisible = false;
  let lastInUseHandlesKey = null;

  let lastInspireHandle = null;
  let designBaseline = null;
  let exitBypass = false;
  let activeSavedDesignId = null;

  const PICKER_H_STORAGE = 'bd-picker-pane-height-v2';
  const PICKER_DEFAULT_VH = 0.36;

  function isMobilePicker() {
    return MOBILE_PICKER_MQ.matches;
  }

  function applyMobileCanvasProfile() {
    if (!canvas) return;
    const mobile = isMobilePicker();
    canvas.beadDisplayScale = mobile ? 0.96 : 1;
    canvas.ringMaxRatio = mobile ? 0.5 : 0.46;
    scheduleCanvasResize();
  }

  function autoFitCanvasZoom() {
    if (!canvas) return;
    if (!beads.length) {
      if (zoom !== 1) applyZoom(1);
      return;
    }
    const fit = canvas.getLayoutFitZoom();
    const next = Math.min(1, fit);
    if (Math.abs(next - zoom) > 0.012) applyZoom(next);
  }

  function scheduleCanvasResize() {
    if (!canvas || canvas.anim) return;
    requestAnimationFrame(() => {
      if (canvas.anim) return;
      canvas.resize();
      autoFitCanvasZoom();
      requestAnimationFrame(() => {
        if (canvas.anim) return;
        canvas.resize();
        autoFitCanvasZoom();
      });
    });
  }

  function pulseCanvas() {
    const wrap = els.canvas?.parentElement;
    if (!wrap) return;
    wrap.classList.remove('bd-canvas-wrap--pulse');
    void wrap.offsetWidth;
    wrap.classList.add('bd-canvas-wrap--pulse');
    window.setTimeout(() => wrap.classList.remove('bd-canvas-wrap--pulse'), 620);
  }

  /** Map bead card center to canvas logical coordinates for fly-in animation. */
  function beadCardToCanvas(card) {
    if (!els.canvas || !card) return null;
    const img = card.querySelector('.bd-bead-card__img') || card;
    const imgRect = img.getBoundingClientRect();
    const canvasRect = els.canvas.getBoundingClientRect();
    if (!canvasRect.width || !canvasRect.height) return null;
    const scale = els.canvas.clientWidth / canvasRect.width;
    return {
      x: (imgRect.left + imgRect.width / 2 - canvasRect.left) * scale,
      y: (imgRect.top + imgRect.height / 2 - canvasRect.top) * scale,
    };
  }

  function flashBeadCard(card) {
    if (!card) return;
    card.classList.remove('bd-bead-card--added');
    void card.offsetWidth;
    card.classList.add('bd-bead-card--added');
    window.setTimeout(() => card.classList.remove('bd-bead-card--added'), 520);
  }

  const ZOOM_MIN = 0.6;
  const ZOOM_MAX = 1.5;
  const DRAG_THRESHOLD_PX = 4;

  function updateCanvasControls() {
    const hasBeads = beads.length > 0;
    if (els.clear) els.clear.hidden = !hasBeads;
  }

  let pendingViewTransform = null;
  let viewTransformRaf = 0;

  function clampCanvasZoom(nextZoom) {
    return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, nextZoom));
  }

  function syncCanvasZoomOverflow() {
    const wrap = els.canvas?.parentElement;
    if (!wrap || !canvas) return;
    const fit = canvas.getLayoutFitZoom?.() ?? 1;
    wrap.classList.toggle('bd-canvas-wrap--zoomed-in', zoom > fit + 0.015);
  }

  function flushViewTransform() {
    viewTransformRaf = 0;
    if (!pendingViewTransform || !canvas) {
      pendingViewTransform = null;
      return;
    }
    const payload = pendingViewTransform;
    pendingViewTransform = null;
    if (payload.zoom !== undefined) {
      zoom = clampCanvasZoom(payload.zoom);
      if (els.zoomLabel) els.zoomLabel.textContent = `${Math.round(zoom * 100)}%`;
      payload.zoom = zoom;
    }
    canvas.applyViewTransform({
      zoom: payload.zoom,
      rotation: payload.rotation,
    });
    syncCanvasZoomOverflow();
  }

  function flushViewTransformSync() {
    if (viewTransformRaf) {
      cancelAnimationFrame(viewTransformRaf);
      viewTransformRaf = 0;
    }
    flushViewTransform();
  }

  /** Batch pinch/rotate updates to one draw per frame (zoom stays CSS-only). */
  function scheduleViewTransform(nextZoom, nextRotation) {
    if (!pendingViewTransform) pendingViewTransform = {};
    if (nextZoom !== undefined) {
      pendingViewTransform.zoom = clampCanvasZoom(nextZoom);
    }
    if (nextRotation !== undefined) {
      pendingViewTransform.rotation = nextRotation;
    }
    if (!viewTransformRaf) {
      viewTransformRaf = requestAnimationFrame(flushViewTransform);
    }
  }

  function applyZoom(nextZoom) {
    flushViewTransformSync();
    zoom = clampCanvasZoom(nextZoom);
    if (els.zoomLabel) els.zoomLabel.textContent = `${Math.round(zoom * 100)}%`;
    canvas.setZoom(zoom);
    syncCanvasZoomOverflow();
  }

  function setupCanvasInteraction() {
    const wrap = els.canvas?.parentElement;
    if (!wrap || !canvas) return;

    const pointers = new Map();
    let gesture = null;

    let docBeadDragMove = null;

    function stopDocBeadDrag() {
      if (!docBeadDragMove) return;
      document.removeEventListener('pointermove', docBeadDragMove);
      docBeadDragMove = null;
    }

    function isOutsideCanvasPanel(clientX, clientY) {
      const panel = els.canvasPanel;
      if (!panel) return false;
      const r = panel.getBoundingClientRect();
      const pad = 6;
      return (
        clientX < r.left + pad ||
        clientX > r.right - pad ||
        clientY < r.top + pad ||
        clientY > r.bottom - pad
      );
    }

    function isOutsideBraceletRing(clientX, clientY) {
      if (!beads.length) return false;
      const pt = canvas.clientToLayoutPointFree(clientX, clientY);
      const layout = canvas.layoutFor(beads, pt.size, pt.cx, pt.cy);
      const dist = Math.hypot(pt.x - pt.cx, pt.y - pt.cy);
      const margin = Math.max(22, layout.baseR * 0.14);
      return dist > layout.baseR + margin;
    }

    function clampClientToStage(clientX, clientY) {
      const panel = els.canvasPanel;
      if (!panel) return { x: clientX, y: clientY };
      const r = panel.getBoundingClientRect();
      const pad = 8;
      return {
        x: Math.max(r.left + pad, Math.min(r.right - pad, clientX)),
        y: Math.max(r.top + pad, Math.min(r.bottom - pad, clientY)),
      };
    }

    function beadDragPoint(clientX, clientY, beadIdx) {
      const pt = canvas.clientToLayoutPointFree(clientX, clientY);
      const layout = canvas.layoutFor(beads, pt.size, pt.cx, pt.cy);
      const slot = layout.slots[beadIdx];
      const x = pt.x;
      const y = pt.y;
      return {
        ...pt,
        x,
        y,
        angle: Math.atan2(y - pt.cy, x - pt.cx),
        slot,
        layout,
      };
    }

    function isDeleteDrop(clientX, clientY) {
      return isOutsideCanvasPanel(clientX, clientY) || isOutsideBraceletRing(clientX, clientY);
    }

    function trackBeadDrag(e) {
      if (!gesture || gesture.type !== 'bead' || !gesture.moved) return;
      gesture.lastClientX = e.clientX;
      gesture.lastClientY = e.clientY;
      const deleteMode = isDeleteDrop(e.clientX, e.clientY);
      wrap.classList.toggle('bd-canvas-wrap--delete', deleteMode);
      updateBeadDragVisual(e.clientX, e.clientY, gesture.beadIdx, deleteMode);
    }

    function clearGesture() {
      flushViewTransformSync();
      gesture = null;
      stopDocBeadDrag();
      wrap.classList.remove('bd-canvas-wrap--grabbing', 'bd-canvas-wrap--delete');
      hideDragGhost();
      canvas.clearDragState();
      canvas.selectedIndex = -1;
    }

    let dragGhostEl = null;

    function hideDragGhost() {
      if (!dragGhostEl) return;
      dragGhostEl.hidden = true;
    }

    function ensureDragGhostEl() {
      if (dragGhostEl) return dragGhostEl;
      dragGhostEl = document.createElement('img');
      dragGhostEl.className = 'bd-drag-ghost';
      dragGhostEl.alt = '';
      dragGhostEl.hidden = true;
      document.body.appendChild(dragGhostEl);
      return dragGhostEl;
    }

    function dragGhostUrl(bead) {
      return Core.resolveBeadThumbUrl(bead);
    }

    function preloadDragGhost(beadIdx) {
      const bead = beads[beadIdx];
      const url = dragGhostUrl(bead);
      if (!url) return;
      const el = ensureDragGhostEl();
      if (el.src !== url) el.src = url;
      if (typeof el.decode === 'function') {
        el.decode().catch(() => {});
      }
    }

    function beadScreenDiameterPx(beadIdx) {
      const size = canvas.getDrawSize();
      const cx = size / 2;
      const cy = size / 2;
      const layout = canvas.layoutFor(beads, size, cx, cy);
      const slot = layout.slots[beadIdx];
      if (!slot) return 56;
      const rect = els.canvas.getBoundingClientRect();
      const scale = (rect.width || size) / size;
      return Math.max(28, Math.min(88, slot.r * 2 * 1.12 * scale * (canvas.zoom || 1)));
    }

    function updateDragGhost(beadIdx, clientX, clientY) {
      const bead = beads[beadIdx];
      if (!bead) {
        hideDragGhost();
        return;
      }
      const url = dragGhostUrl(bead);
      if (!url) {
        hideDragGhost();
        return;
      }
      const el = ensureDragGhostEl();
      if (el.src !== url) el.src = url;
      const d = beadScreenDiameterPx(beadIdx);
      el.style.width = `${d}px`;
      el.style.height = `${d}px`;
      el.style.transform = `translate(${clientX}px, ${clientY}px) translate(-50%, -50%)`;
      el.hidden = false;
    }

    function isDragGhostReady() {
      const el = dragGhostEl;
      return !!el?.complete && el.naturalWidth > 0;
    }

    /** Single drag renderer — ghost follows finger; ring bead hidden only after ghost is placed. */
    function updateBeadDragVisual(clientX, clientY, beadIdx, deleteMode) {
      const drag = beadDragPoint(clientX, clientY, beadIdx);
      gesture.dropAngle = drag.angle;
      const ghostPt = deleteMode
        ? { x: clientX, y: clientY }
        : clampClientToStage(clientX, clientY);

      updateDragGhost(beadIdx, ghostPt.x, ghostPt.y);
      canvas.setDragState({
        index: beadIdx,
        x: drag.x,
        y: drag.y,
        angle: gesture.angle,
        free: true,
        scale: deleteMode ? 0.92 : 1.12,
        opacity: 0,
      });
    }

    function handoffBeadDragGhost(clientX, clientY) {
      if (!gesture || gesture.type !== 'bead' || !gesture.moved) return;
      updateDragGhost(gesture.beadIdx, clientX, clientY);
      if (dragGhostEl) void dragGhostEl.offsetHeight;
      updateBeadDragVisual(clientX, clientY, gesture.beadIdx, isDeleteDrop(clientX, clientY));
    }

    function beginBeadDragMove(e) {
      gesture.moved = true;
      gesture.lastClientX = e.clientX;
      gesture.lastClientY = e.clientY;
      wrap.classList.add('bd-canvas-wrap--grabbing');

      if (!docBeadDragMove) {
        docBeadDragMove = (ev) => trackBeadDrag(ev);
        document.addEventListener('pointermove', docBeadDragMove, { passive: true });
      }

      // Keep ring slot empty on canvas; only the HTML ghost follows the finger.
      canvas.setDragState({
        index: gesture.beadIdx,
        x: gesture.startLayoutX,
        y: gesture.startLayoutY,
        angle: gesture.angle,
        free: true,
        scale: 1,
        opacity: 0,
      });

      if (isDragGhostReady()) {
        handoffBeadDragGhost(e.clientX, e.clientY);
        return;
      }

      const el = ensureDragGhostEl();
      el.addEventListener(
        'load',
        () => {
          if (!gesture?.moved) return;
          handoffBeadDragGhost(gesture.lastClientX ?? e.clientX, gesture.lastClientY ?? e.clientY);
        },
        { once: true }
      );
      el.addEventListener(
        'error',
        () => {
          if (!gesture?.moved) return;
          handoffBeadDragGhost(gesture.lastClientX ?? e.clientX, gesture.lastClientY ?? e.clientY);
        },
        { once: true }
      );
    }

    function pinchMetrics() {
      const pts = [...pointers.values()];
      if (pts.length < 2) return null;
      const [a, b] = pts;
      const dx = b.x - a.x;
      const dy = b.y - a.y;
      return {
        distance: Math.hypot(dx, dy),
        angle: Math.atan2(dy, dx),
        cx: (a.x + b.x) / 2,
        cy: (a.y + b.y) / 2,
      };
    }

    wrap.addEventListener(
      'wheel',
      (e) => {
        if (!beads.length && zoom === 1) return;
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.08 : 0.08;
        applyZoom(zoom + delta);
      },
      { passive: false }
    );

    els.canvas.addEventListener('pointerdown', (e) => {
      if (canvas.anim) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      els.canvas.setPointerCapture(e.pointerId);

      if (pointers.size === 2) {
        const m = pinchMetrics();
        if (!m) return;
        gesture = {
          type: 'pinch',
          startDistance: m.distance,
          startAngle: m.angle,
          startZoom: zoom,
          startRotation: canvas.getViewRotation(),
        };
        return;
      }

      const beadIdx = canvas.hitTest(e.clientX, e.clientY);
      const onRing = canvas.hitRing(e.clientX, e.clientY);
      const rect = els.canvas.getBoundingClientRect();
      const screenCx = rect.left + rect.width / 2;
      const screenCy = rect.top + rect.height / 2;

      if (beadIdx >= 0) {
        const pt = canvas.clientToLayoutPoint(e.clientX, e.clientY);
        const layout = canvas.layoutFor(beads, pt.size, pt.cx, pt.cy);
        const slot = layout.slots[beadIdx];
        const slotAngle = slot?.angle ?? -Math.PI / 2;
        preloadDragGhost(beadIdx);
        hideDragGhost();
        const startLayoutX = slot?.x ?? pt.x;
        const startLayoutY = slot?.y ?? pt.y;
        gesture = {
          type: 'bead',
          beadIdx,
          startX: e.clientX,
          startY: e.clientY,
          moved: false,
          angle: slotAngle,
          dropAngle: slotAngle,
          startLayoutX,
          startLayoutY,
        };
        return;
      }

      if (onRing || beads.length > 0) {
        gesture = {
          type: 'rotate',
          startRotation: canvas.getViewRotation(),
          startPointerAngle: Math.atan2(e.clientY - screenCy, e.clientX - screenCx),
          screenCx,
          screenCy,
        };
        wrap.classList.add('bd-canvas-wrap--grabbing');
      }
    });

    els.canvas.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (gesture?.type === 'pinch' && pointers.size >= 2) {
        const m = pinchMetrics();
        if (!m || !gesture.startDistance) return;
        const scale = m.distance / gesture.startDistance;
        const delta = Core.angleDelta(gesture.startAngle, m.angle);
        scheduleViewTransform(gesture.startZoom * scale, gesture.startRotation + delta);
        return;
      }

      if (gesture?.type === 'bead') {
        const dist = Math.hypot(e.clientX - gesture.startX, e.clientY - gesture.startY);

        if (!gesture.moved && dist >= DRAG_THRESHOLD_PX) {
          beginBeadDragMove(e);
        }

        if (gesture.moved) {
          trackBeadDrag(e);
        }
        return;
      }

      if (gesture?.type === 'rotate') {
        const pointerAngle = Math.atan2(
          e.clientY - gesture.screenCy,
          e.clientX - gesture.screenCx
        );
        const delta = Core.angleDelta(gesture.startPointerAngle, pointerAngle);
        scheduleViewTransform(undefined, gesture.startRotation + delta);
      }
    });

    function finishPointer(e) {
      pointers.delete(e.pointerId);
      try {
        els.canvas.releasePointerCapture(e.pointerId);
      } catch {
        /* already released */
      }

      if (pointers.size === 1 && gesture?.type === 'pinch') {
        flushViewTransformSync();
        const remaining = [...pointers.entries()][0];
        gesture = null;
        pointers.clear();
        pointers.set(remaining[0], remaining[1]);
        return;
      }

      if (pointers.size > 0) return;

      const beadGesture = gesture?.type === 'bead' ? gesture : null;
      if (beadGesture) {
        const { beadIdx, moved } = beadGesture;
        const dropX = beadGesture.lastClientX ?? e.clientX;
        const dropY = beadGesture.lastClientY ?? e.clientY;
        clearGesture();

        if (moved && isDeleteDrop(dropX, dropY)) {
          removeBead(beadIdx);
        } else if (moved && beads.length > 1) {
          const stagePt = clampClientToStage(dropX, dropY);
          const pt = canvas.clientToLayoutPointFree(stagePt.x, stagePt.y);
          const layout = canvas.layoutFor(beads, pt.size, pt.cx, pt.cy);
          const { beads: nextBeads, changed } = Core.reorderBeadsInGap(
            beads,
            beadIdx,
            pt.x,
            pt.y,
            layout
          );
          if (changed) {
            beads = nextBeads;
            syncCanvas({
              animate: true,
              onLand: () => window.DesignerSounds?.playRemove?.(),
            });
          } else {
            canvas.draw();
          }
        } else {
          canvas.draw();
        }
      } else {
        clearGesture();
      }
    }

    els.canvas.addEventListener('pointerup', finishPointer);
    els.canvas.addEventListener('pointercancel', finishPointer);
  }

  function measureDefaultPickerHeight() {
    syncBeadGridViewport();
    const head = root.querySelector('.bd-picker-sheet-head');
    const search = root.querySelector('.bd-search');
    const gridH = parseFloat(getComputedStyle(root).getPropertyValue('--bd-bead-grid-min')) || 0;
    let chrome = 0;
    if (head) chrome += head.offsetHeight;
    if (search) chrome += search.offsetHeight;
    const total = chrome + (gridH > 0 ? gridH : 240) + 12;
    const measured = total > 0 ? total : 320;
    const viewportH = window.visualViewport?.height || window.innerHeight;
    return Math.min(measured, Math.round(viewportH * PICKER_DEFAULT_VH));
  }

  function readPickerHeightPx() {
    const raw = root.style.getPropertyValue('--bd-picker-pane-h').trim();
    const parsed = parseFloat(raw);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
    return measureDefaultPickerHeight();
  }

  function applyPickerHeight(px, opts = {}) {
    if (!isMobilePicker()) return;
    const minH = measureDefaultPickerHeight();
    const viewportH = window.visualViewport?.height || window.innerHeight;
    const maxH = Math.round(viewportH * 0.72);
    const h = Math.min(maxH, Math.max(minH, Math.round(px)));
    root.style.setProperty('--bd-picker-pane-h', `${h}px`);
    syncBeadGridViewport();
    try {
      localStorage.setItem(PICKER_H_STORAGE, String(h));
    } catch {
      /* ignore */
    }
    if (!opts.skipCanvasResize) {
      scheduleCanvasResize();
    }
  }

  function syncCanvasToPickerHeight() {
    if (!isMobilePicker() || !root.classList.contains('bd-picker-open')) return;
    scheduleCanvasResize();
  }

  function restorePickerHeight() {
    let stored = null;
    try {
      stored = Number(localStorage.getItem(PICKER_H_STORAGE));
    } catch {
      /* ignore */
    }
    if (Number.isFinite(stored) && stored > 0) {
      applyPickerHeight(stored);
    } else {
      root.style.removeProperty('--bd-picker-pane-h');
    }
  }

  function setupPickerResize() {
    if (isMobilePicker()) return;
    const head = els.pickerResize;
    if (!head) return;

    restorePickerHeight();

    els.pickerClose?.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
    });

    let drag = null;

    head.addEventListener('pointerdown', (e) => {
      if (!isMobilePicker() || !root.classList.contains('bd-picker-open')) return;
      if (e.target.closest('[data-bd-picker-close]')) return;
      drag = { startY: e.clientY, startH: readPickerHeightPx() };
      head.setPointerCapture(e.pointerId);
      head.classList.add('is-dragging');
      els.picker?.classList.add('is-resizing');
    });

    head.addEventListener('pointermove', (e) => {
      if (!drag) return;
      applyPickerHeight(drag.startH + (drag.startY - e.clientY), { skipCanvasResize: true });
      syncCanvasToPickerHeight();
    });

    const endDrag = (e) => {
      if (!drag) return;
      drag = null;
      head.classList.remove('is-dragging');
      els.picker?.classList.remove('is-resizing');
      try {
        head.releasePointerCapture(e.pointerId);
      } catch {
        /* ignore */
      }
      syncCanvasToPickerHeight();
    };

    head.addEventListener('pointerup', endDrag);
    head.addEventListener('pointercancel', endDrag);
  }

  function setPickerOpen(open) {
    if (!isMobilePicker()) return;
    // Mobile uses a fixed split layout; the picker is always visible.
    void open;
  }

  function renderPickerToggleButton() {
    /* Mobile picker is always visible in the fixed split layout. */
  }

  let toastTimer = null;

  const TOAST_ICON = {
    success:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>',
    error:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M15 9l-6 6M9 9l6 6"/></svg>',
    limit:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 9v4M12 17h.01"/><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg>',
    info:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>',
  };

  function resolveToastType(isErrorOrOpts, opts = {}) {
    if (typeof isErrorOrOpts === 'object' && isErrorOrOpts !== null) {
      const merged = isErrorOrOpts;
      if (merged.type) return merged.type;
      if (merged.limit) return 'limit';
      if (merged.error) return 'error';
      return 'success';
    }
    if (opts.type) return opts.type;
    if (opts.limit) return 'limit';
    if (isErrorOrOpts) return 'error';
    return 'success';
  }

  function showToast(msg, isErrorOrOpts = false, opts = {}) {
    if (!els.toast) return;
    const options = typeof isErrorOrOpts === 'object' && isErrorOrOpts !== null ? isErrorOrOpts : opts;
    const type = resolveToastType(isErrorOrOpts, options);

    if (toastTimer) clearTimeout(toastTimer);

    if (els.toastText) els.toastText.textContent = msg;
    else els.toast.textContent = msg;

    if (els.toastIcon) {
      els.toastIcon.innerHTML = TOAST_ICON[type] || TOAST_ICON.info;
    }

    els.toast.hidden = false;
    els.toast.classList.remove('bd-toast--success', 'bd-toast--error', 'bd-toast--limit', 'bd-toast--info');
    els.toast.classList.add(`bd-toast--${type}`, 'is-visible');

    const ms = type === 'limit' ? 2400 : type === 'error' ? 4200 : 2800;
    toastTimer = setTimeout(() => {
      els.toast.classList.remove('is-visible', 'bd-toast--success', 'bd-toast--error', 'bd-toast--limit', 'bd-toast--info');
      toastTimer = null;
      window.setTimeout(() => {
        if (!els.toast.classList.contains('is-visible')) {
          els.toast.hidden = true;
        }
      }, 260);
    }, ms);
  }

  function showLimitToast(msg) {
    showToast(msg, { type: 'limit' });
    pulseCanvas();
  }

  const confirmRoot = document.querySelector('[data-bd-confirm]');
  let confirmPending = null;

  function setupConfirmDialog() {
    if (!confirmRoot) return null;

    const backdrop = confirmRoot.querySelector('[data-bd-confirm-backdrop]');
    const cancelBtn = confirmRoot.querySelector('[data-bd-confirm-cancel]');
    const okBtn = confirmRoot.querySelector('[data-bd-confirm-ok]');
    const titleEl = confirmRoot.querySelector('[data-bd-confirm-title]');
    const messageEl = confirmRoot.querySelector('[data-bd-confirm-message]');

    function settle(result) {
      if (!confirmPending) return;
      confirmRoot.classList.remove('is-visible');
      document.body.classList.remove('bd-confirm-open');
      const resolve = confirmPending;
      confirmPending = null;
      window.setTimeout(() => {
        confirmRoot.hidden = true;
        confirmRoot.setAttribute('aria-hidden', 'true');
        cancelBtn.hidden = false;
        confirmRoot.querySelector('.bd-confirm__actions')?.classList.remove('bd-confirm__actions--alert');
      }, 220);
      resolve(result);
    }

    cancelBtn?.addEventListener('click', () => settle(false));
    backdrop?.addEventListener('click', () => settle(false));
    okBtn?.addEventListener('click', () => settle(true));

    document.addEventListener('keydown', (e) => {
      if (confirmRoot.hidden || !confirmPending) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        settle(false);
      }
    });

    return { titleEl, messageEl, okBtn, cancelBtn, actionsEl: confirmRoot.querySelector('.bd-confirm__actions') };
  }

  const confirmUI = setupConfirmDialog();

  const busyRoot = document.querySelector('[data-bd-busy]');
  const busyTitle = busyRoot?.querySelector('[data-bd-busy-title]');

  function showBusyOverlay(mode = 'add') {
    if (!busyRoot) return;
    const title =
      mode === 'checkout'
        ? busyRoot.dataset.busyCheckout || 'Opening checkout…'
        : busyRoot.dataset.busyAdd || 'Adding to cart…';
    if (busyTitle) busyTitle.textContent = title;
    busyRoot.hidden = false;
    busyRoot.setAttribute('aria-busy', 'true');
    document.body.classList.add('bd-busy-open');
  }

  function hideBusyOverlay() {
    if (!busyRoot) return;
    busyRoot.hidden = true;
    busyRoot.setAttribute('aria-busy', 'false');
    document.body.classList.remove('bd-busy-open');
  }

  function setSaveLoading(loading) {
    if (!els.save) return;
    els.save.disabled = loading;
    els.save.classList.toggle('is-loading', loading);
    els.save.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (els.saveSpinner) els.saveSpinner.hidden = !loading;
    if (loading && els.saveLabel) els.saveLabel.textContent = i18n.saveSaving;
    if (!loading) updateSaveButtonAuthState();
  }

  function updateSaveButtonAuthState() {
    if (!els.save || els.save.classList.contains('is-loading')) return;
    const cloudEnabled = window.DesignCloudApi?.enabled?.();
    const needsLogin = cloudEnabled && !Core.isLoggedInCustomer();
    els.save.classList.toggle('is-login-required', needsLogin);
    els.save.setAttribute('aria-disabled', needsLogin ? 'true' : 'false');
    if (els.saveLabel) {
      els.saveLabel.textContent = needsLogin ? i18n.saveLogin : i18n.save;
    }
  }

  function redirectToLoginForSave() {
    window.location.href = loginUrlForReturn();
  }

  function handleSaveClick() {
    if (window.DesignCloudApi?.enabled?.() && !Core.isLoggedInCustomer()) {
      redirectToLoginForSave();
      return;
    }
    saveToMyDesigns();
  }

  function setDesignLoading(loading) {
    root.classList.toggle('bd-root--design-loading', loading);
    if (els.canvasWrap) {
      els.canvasWrap.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  function showConfirmDialog({
    title = 'Confirm',
    message = '',
    confirmText = 'Continue',
    cancelText = 'Cancel',
    variant = 'default',
    mode = 'confirm',
  } = {}) {
    if (!confirmUI) return Promise.resolve(window.confirm(message || title));

    return new Promise((resolve) => {
      confirmPending = resolve;
      confirmUI.titleEl.textContent = title;
      confirmUI.messageEl.textContent = message;
      confirmUI.okBtn.textContent = confirmText;
      confirmUI.cancelBtn.textContent = cancelText;
      confirmUI.okBtn.classList.remove('bd-confirm__btn--danger', 'bd-confirm__btn--inspire', 'bd-confirm__btn--success');
      if (variant === 'inspire') {
        confirmUI.okBtn.classList.add('bd-confirm__btn--inspire');
      } else if (variant === 'danger') {
        confirmUI.okBtn.classList.add('bd-confirm__btn--danger');
      } else if (variant === 'success') {
        confirmUI.okBtn.classList.add('bd-confirm__btn--success');
      }

      const isAlert = mode === 'alert';
      confirmUI.cancelBtn.hidden = isAlert;
      confirmUI.actionsEl?.classList.toggle('bd-confirm__actions--alert', isAlert);

      confirmRoot.hidden = false;
      confirmRoot.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bd-confirm-open');
      requestAnimationFrame(() => confirmRoot.classList.add('is-visible'));
      (isAlert ? confirmUI.okBtn : confirmUI.cancelBtn).focus();
    });
  }

  function designSnapshot() {
    const circ = Core.calcCircumferenceCm(beads);
    const wristForSnap = beads.length
      ? Core.roundWristCm(getCheckoutWristCm(circ))
      : Core.roundWristCm(wristSizeCm);
    return {
      title: (els.title?.value || '').trim() || 'My Crystal Bracelet',
      design: JSON.stringify(Core.compactDesignJson(beads, wristForSnap)),
    };
  }

  function commitDesignBaseline() {
    designBaseline = designSnapshot();
  }

  function isDesignDirty() {
    if (!designBaseline) return false;
    const current = designSnapshot();
    return current.title !== designBaseline.title || current.design !== designBaseline.design;
  }

  function confirmLeaveDesigner() {
    return showConfirmDialog({
      title: 'Leave designer?',
      message: 'You have unsaved changes. Leaving will discard your edits.',
      confirmText: 'Leave',
      cancelText: 'Stay',
      variant: 'danger',
    });
  }

  async function navigateAway(url) {
    if (exitBypass || !isDesignDirty()) {
      exitBypass = true;
      window.location.assign(url);
      return;
    }
    const ok = await confirmLeaveDesigner();
    if (!ok) return;
    exitBypass = true;
    window.location.assign(url);
  }

  function setupTitleEditor() {
    const title = els.title;
    const editBtn = els.titleEdit;
    if (!title || !editBtn || title.dataset.bdTitleBound === '1') return;
    title.dataset.bdTitleBound = '1';

    const defaultTitle = 'My Crystal Bracelet';
    const TITLE_DISPLAY_MAX_CHARS = 10;

    let titleMeasureCanvas;

    function measureTitleTextPx(text) {
      const sample = text || defaultTitle;
      if (!titleMeasureCanvas) {
        titleMeasureCanvas = document.createElement('canvas');
      }
      const ctx = titleMeasureCanvas.getContext('2d');
      if (!ctx) return sample.length * 9;
      const cs = getComputedStyle(title);
      ctx.font = `${cs.fontStyle} ${cs.fontVariant} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
      return Math.ceil(ctx.measureText(sample).width);
    }

    function syncTitleInputWidth() {
      const text = (title.value || '').trim() || defaultTitle;

      if (title.readOnly && text.length <= TITLE_DISPLAY_MAX_CHARS) {
        title.style.width = `${measureTitleTextPx(text) + 4}px`;
        title.style.maxWidth = '';
        title.classList.remove('bd-header__title-input--truncated');
        title.removeAttribute('title');
        return;
      }

      if (title.readOnly && text.length > TITLE_DISPLAY_MAX_CHARS) {
        const capPx = measureTitleTextPx(text.slice(0, TITLE_DISPLAY_MAX_CHARS)) + 4;
        title.style.width = `${capPx}px`;
        title.style.maxWidth = `${capPx}px`;
        title.classList.add('bd-header__title-input--truncated');
        title.title = text;
        return;
      }

      const px = measureTitleTextPx(text);
      const maxPx = measureTitleTextPx('M'.repeat(36));
      title.style.maxWidth = '';
      title.style.width = `${Math.min(px + 8, maxPx)}px`;
      title.classList.remove('bd-header__title-input--truncated');
      title.removeAttribute('title');
    }

    function setTitleReadonly(readonly) {
      title.readOnly = readonly;
      title.tabIndex = readonly ? -1 : 0;
      title.classList.toggle('bd-header__title-input--readonly', readonly);
      syncTitleInputWidth();
    }

    function beginTitleEdit() {
      setTitleReadonly(false);
      title.focus();
      title.select();
    }

    setTitleReadonly(true);
    title.addEventListener('input', syncTitleInputWidth);

    editBtn.addEventListener('click', beginTitleEdit);

    title.addEventListener('blur', () => {
      const trimmed = title.value.trim();
      title.value = trimmed || defaultTitle;
      setTitleReadonly(true);
    });

    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        title.blur();
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        title.blur();
      }
    });
  }

  function setupDesignerNav() {
    const toggle = root.querySelector('[data-bd-nav-toggle]');
    const drawer = root.querySelector('[data-bd-nav-drawer]');
    if (!toggle || !drawer || toggle.dataset.bdNavBound === '1') return;
    toggle.dataset.bdNavBound = '1';

    const panel = drawer.querySelector('.bd-nav-drawer__panel');
    const closeEls = drawer.querySelectorAll('[data-bd-nav-close]');
    const links = drawer.querySelectorAll('a.bd-nav-drawer__link');
    let suppressBackdropCloseUntil = 0;

    function isDrawerOpen() {
      return drawer.classList.contains('is-open');
    }

    function syncClosedState() {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bd-nav-open');
    }

    function openDrawer() {
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      suppressBackdropCloseUntil = Date.now() + 450;
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('bd-nav-open');
      });
    }

    function closeDrawer() {
      if (!isDrawerOpen() && drawer.hidden) return;
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bd-nav-open');

      const onEnd = (e) => {
        if (e.target !== panel) return;
        drawer.hidden = true;
        drawer.setAttribute('aria-hidden', 'true');
        panel?.removeEventListener('transitionend', onEnd);
      };
      panel?.addEventListener('transitionend', onEnd);

      window.setTimeout(() => {
        if (!isDrawerOpen()) {
          drawer.hidden = true;
          drawer.setAttribute('aria-hidden', 'true');
        }
      }, 320);
    }

    function handleCloseClick(e) {
      if (
        e.currentTarget instanceof HTMLElement &&
        e.currentTarget.classList.contains('bd-nav-drawer__backdrop') &&
        Date.now() < suppressBackdropCloseUntil
      ) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      closeDrawer();
    }

    if (drawer.hidden || !isDrawerOpen()) {
      syncClosedState();
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isDrawerOpen()) {
        closeDrawer();
        return;
      }
      openDrawer();
    });

    closeEls.forEach((el) => {
      el.addEventListener('click', handleCloseClick);
    });

    links.forEach((link) => {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDrawerOpen()) closeDrawer();
    });

    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth >= 1024 && isDrawerOpen()) {
          syncClosedState();
        }
      },
      { passive: true }
    );
  }

  function setupExitGuard() {
    root.querySelectorAll('[data-bd-exit]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (exitBypass || !isDesignDirty()) return;
        e.preventDefault();
        navigateAway(link.href);
      });
    });

    window.addEventListener('beforeunload', (e) => {
      if (exitBypass || !isDesignDirty()) return;
      e.preventDefault();
      e.returnValue = '';
    });

    history.pushState({ bdDesignerExitGuard: true }, '');
    window.addEventListener('popstate', () => {
      if (exitBypass) return;
      if (!isDesignDirty()) {
        exitBypass = true;
        history.back();
        return;
      }
      history.pushState({ bdDesignerExitGuard: true }, '');
      confirmLeaveDesigner().then((ok) => {
        if (!ok) return;
        exitBypass = true;
        history.go(-2);
      });
    });
  }

  /** ok | blocked (cannot add beads) */
  function wristLimitState(circ) {
    const maxArc = maxCircumferenceCm();
    if (beads.length === 0) return 'ok';
    if (circ >= maxArc - 0.001) return 'blocked';
    return 'ok';
  }

  function formatMoney(n) {
    return `$${Number(n).toFixed(2)}`;
  }

  function clampWrist(cm) {
    const n = Number(cm);
    if (!Number.isFinite(n)) return WRIST_DEFAULT_CM;
    return Math.min(WRIST_MAX_CM, Math.max(WRIST_MIN_CM, n));
  }

  /** Target wrist for FIT % (template default, grows with beads up to WRIST_MAX_CM). */
  function getTargetWristCm(circ) {
    const base = clampWrist(wristSizeCm);
    if (!beads.length) return base;
    return clampWrist(Math.max(base, circ));
  }

  /** Wrist passed to cart / line item properties. */
  function getCheckoutWristCm(circ) {
    if (beads.length > 0) return clampWrist(circ);
    return clampWrist(wristSizeCm);
  }

  function maxCircumferenceCm() {
    return WRIST_MAX_CM;
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function updateMeta() {
    const total = Core.calcTotal(beads);
    const circ = Core.calcCircumferenceCm(beads);
    const target = getTargetWristCm(circ);
    const fitPct = target > 0 ? Math.round((circ / target) * 100) : 0;
    const checkoutWrist = getCheckoutWristCm(circ);

    if (els.total) els.total.textContent = `TOTAL ${formatMoney(total)}`;
    const limitState = wristLimitState(circ);
    root.classList.toggle('bd--max-wrist', limitState === 'blocked');

    if (els.fit) {
      els.fit.classList.remove('bd-badge--limit');
      if (beads.length === 0) {
        els.fit.textContent = 'FIT —';
        els.fit.style.color = '';
      } else if (limitState === 'blocked') {
        els.fit.textContent = `MAX ${Core.formatWristCmIn(WRIST_MAX_CM)}`;
        els.fit.classList.add('bd-badge--limit');
        els.fit.style.color = '';
      } else {
        els.fit.textContent = `FIT ${fitPct}% · ${Core.formatWristCmIn(checkoutWrist)}`;
        els.fit.style.color = fitPct > 108 ? '#c0392b' : '';
      }
    }

    const blockers = getCheckoutBlockers(fitPct);
    renderConfirmButton(blockers);
    renderPickerToggleButton();
    updateCanvasControls();
  }

  function renderConfirmButton(blockers = null) {
    const btn = els.buyNow;
    const label = els.confirmLabel;
    if (!btn || !label) return;

    const circ = Core.calcCircumferenceCm(beads);
    const target = getTargetWristCm(circ);
    const fitPct = target > 0 ? Math.round((circ / target) * 100) : 0;
    const issues = blockers ?? getCheckoutBlockers(fitPct);
    const ready = issues.length === 0;

    if (beads.length === 0) {
      label.textContent = i18n.selectBeads;
      btn.dataset.action = 'select-beads';
      btn.classList.remove('bd-toolbar-btn--locked');
      btn.setAttribute('aria-disabled', 'false');
    } else {
      label.textContent = i18n.confirmDesign;
      btn.dataset.action = ready ? 'confirm' : 'confirm-blocked';
      btn.classList.toggle('bd-toolbar-btn--locked', !ready);
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
  }

  function getCheckoutBlockers(fitPct) {
    const min = cfg.minBeads || 12;
    const issues = [];
    if (!cfg.customBraceletVariantId) {
      issues.push('Configure Custom Crystal Bracelet product in Shopify Admin');
    }
    const missingVariants = Core.beadsMissingVariantIds(beads);
    if (beads.length > 0 && missingVariants.length) {
      issues.push(
        `${missingVariants.length} bead(s) missing Shopify variant — run scripts/sync-bead-variants-shopify.mjs`
      );
    }
    if (beads.length < min) {
      issues.push(`Add at least ${min} beads (${beads.length}/${min})`);
    }
    if (beads.length > 0 && fitPct > 108) {
      issues.push('FIT over 100% — remove some beads');
    }
    const circ = Core.calcCircumferenceCm(beads);
    if (beads.length > 0 && circ > maxCircumferenceCm()) {
      issues.push(`Max wrist ${WRIST_MAX_CM}cm reached — remove beads`);
    }
    return issues;
  }

  function getInUseHandles() {
    const seen = new Set();
    const handles = [];
    for (const bead of beads) {
      const handle = bead?.handle;
      if (!handle || seen.has(handle)) continue;
      seen.add(handle);
      handles.push(handle);
    }
    return handles;
  }

  function inUseHandlesKey() {
    return getInUseHandles().sort().join('\0');
  }

  function visibleCategories() {
    if (!beads.length) return categories;
    return [{ id: IN_USE_CATEGORY, label: i18n.categoryInUse }, ...categories];
  }

  function refreshInUseCategory() {
    const showInUse = beads.length > 0;
    const handlesKey = showInUse ? inUseHandlesKey() : null;

    if (!showInUse) {
      if (activeCategory === IN_USE_CATEGORY) activeCategory = 'all';
      if (inUseCategoryVisible) renderCategories();
      inUseCategoryVisible = false;
      lastInUseHandlesKey = null;
      return;
    }

    if (!inUseCategoryVisible) {
      renderCategories();
      inUseCategoryVisible = true;
      lastInUseHandlesKey = handlesKey;
      if (activeCategory === IN_USE_CATEGORY) renderGrid();
      return;
    }

    if (activeCategory === IN_USE_CATEGORY && handlesKey !== lastInUseHandlesKey) {
      lastInUseHandlesKey = handlesKey;
      renderGrid();
      return;
    }

    lastInUseHandlesKey = handlesKey;
  }

  function filteredCatalog() {
    const q = searchQuery.trim().toLowerCase();
    const inUseSet =
      activeCategory === IN_USE_CATEGORY ? new Set(getInUseHandles()) : null;
    return Core.BEADS().filter((b) => {
      if (b.enabled === false) return false;
      if (inUseSet) {
        if (!inUseSet.has(b.handle)) return false;
      } else {
        const cats = Array.isArray(b.category) ? b.category : [b.category];
        if (activeCategory !== 'all' && !cats.includes(activeCategory)) return false;
      }
      if (!q) return true;
      const hay = `${b.name} ${b.tags || ''}`.toLowerCase();
      return hay.includes(q);
    });
  }

  function renderCategories() {
    if (!els.categories) return;
    els.categories.innerHTML = visibleCategories()
      .map((c) => {
        const active = c.id === activeCategory;
        return `<button type="button" class="bd-cat-btn${active ? ' is-active' : ''}" data-cat="${c.id}">${escapeHtml(c.label)}</button>`;
      })
      .join('');
    els.categories.querySelectorAll('[data-cat]').forEach((btn) => {
      btn.addEventListener('click', () => {
        activeCategory = btn.dataset.cat;
        renderCategories();
        renderGrid();
      });
    });
  }

  /** Center logo on canvas (under beads), not HTML overlay. */
  async function setupCenterLogo() {
    if (!canvas) return;

    const logoUrl = String(cfg.centerLogoUrl || '').trim();
    canvas.centerLogoUrl = logoUrl;
    canvas.brandName = '';
    canvas.skipCenterBrand = !logoUrl;
    canvas.centerLogoImage = null;

    const slot = els.canvas?.parentElement?.querySelector('[data-bd-center-label]');
    if (slot) slot.hidden = true;

    if (logoUrl) {
      await canvas.preloadCenterLogo();
    } else {
      canvas.draw();
    }
  }

  const CAMERA_ICON =
    '<svg class="bd-bead-card__photos-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>';

  function getBeadActualPhotos(bead) {
    const raw = bead?.actual_photos;
    if (!Array.isArray(raw)) return [];
    return raw.filter((url) => typeof url === 'string' && url.trim());
  }

  const actualPhotosRoot = document.querySelector('[data-bd-actual-photos]');
  let actualPhotosOpen = false;

  function setupActualPhotosSheet() {
    if (!actualPhotosRoot) return null;

    const backdrop = actualPhotosRoot.querySelector('[data-bd-actual-photos-backdrop]');
    const closeBtn = actualPhotosRoot.querySelector('[data-bd-actual-photos-close]');
    const nameEl = actualPhotosRoot.querySelector('[data-bd-actual-photos-name]');
    const trackEl = actualPhotosRoot.querySelector('[data-bd-actual-photos-track]');
    const viewLabel = actualPhotosRoot.dataset.labelView || 'View actual product photos';

    function closeActualPhotosSheet() {
      if (!actualPhotosOpen) return;
      actualPhotosOpen = false;
      actualPhotosRoot.classList.remove('is-visible');
      document.body.classList.remove('bd-actual-photos-open');
      window.setTimeout(() => {
        actualPhotosRoot.hidden = true;
        actualPhotosRoot.setAttribute('aria-hidden', 'true');
        if (trackEl) trackEl.innerHTML = '';
      }, 220);
    }

    function openActualPhotosSheet(bead) {
      if (!bead || !trackEl) return;
      const photos = getBeadActualPhotos(bead);
      if (!photos.length) return;

      if (nameEl) nameEl.textContent = displayBeadName(bead);
      trackEl.innerHTML = photos
        .map(
          (url, i) =>
            `<figure class="bd-actual-photos__item" role="listitem">
              <img src="${escapeHtml(url)}" alt="" width="280" height="280" loading="lazy" decoding="async">
            </figure>`
        )
        .join('');

      actualPhotosRoot.hidden = false;
      actualPhotosRoot.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bd-actual-photos-open');
      requestAnimationFrame(() => actualPhotosRoot.classList.add('is-visible'));
      actualPhotosOpen = true;
    }

    backdrop?.addEventListener('click', closeActualPhotosSheet);
    closeBtn?.addEventListener('click', closeActualPhotosSheet);

    document.addEventListener('keydown', (e) => {
      if (actualPhotosRoot.hidden || !actualPhotosOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeActualPhotosSheet();
      }
    });

    return { openActualPhotosSheet, closeActualPhotosSheet, viewLabel };
  }

  const actualPhotosUI = setupActualPhotosSheet();

  function displayBeadName(bead) {
    let name = String(bead?.name || bead?.handle || '').trim();
    if (!name) return '';

    const diam = Number(bead?.diameter_mm);
    if (Number.isFinite(diam) && diam > 0) {
      const exact = name.replace(new RegExp(`\\s*${diam}(?:\\.0)?\\s*mm\\s*$`, 'i'), '').trim();
      if (exact) name = exact;
    }

    const generic = name.replace(/\s+\d+(?:\.\d+)?\s*mm\s*$/i, '').trim();
    return generic || name;
  }

  /** At least 2 rows tall; grid area grows to fill picker when panel is taller. */
  function computeBeadRowHeightFromCss() {
    const style = getComputedStyle(root);
    const rowVar = parseFloat(style.getPropertyValue('--bd-bead-row-height'));
    if (Number.isFinite(rowVar) && rowVar > 8) return Math.ceil(rowVar);
    const colSize = parseFloat(style.getPropertyValue('--bd-bead-col-size'));
    if (Number.isFinite(colSize) && colSize > 8) {
      return Math.ceil(colSize + parseFloat(style.fontSize || '16') * 0.9);
    }
    return 0;
  }

  function syncBeadGridViewport() {
    const card = root.querySelector('.bd-bead-card');
    let rowH = computeBeadRowHeightFromCss();
    if (card) {
      const measured = Math.ceil(card.getBoundingClientRect().height);
      if (measured > rowH) rowH = measured;
    }
    if (rowH <= 8) return;

    const gap = isMobilePicker() ? 4 : 8;
    const gridMin = rowH * 2 + gap;
    root.style.setProperty('--bd-bead-row-height', `${rowH}px`);
    root.style.setProperty('--bd-bead-grid-min', `${gridMin}px`);
    root.style.setProperty('--bd-bead-grid-viewport', `${gridMin}px`);

    if (isMobilePicker()) {
      const search = root.querySelector('.bd-search');
      const searchH = search?.offsetHeight || 36;
      const pickerH = Math.ceil(searchH + gridMin + 8);
      const cssPicker = parseFloat(getComputedStyle(root).getPropertyValue('--bd-picker-fixed-h'));
      const nextPickerH = Number.isFinite(cssPicker) ? Math.max(pickerH, cssPicker) : pickerH;
      root.style.setProperty('--bd-picker-fixed-h', `${nextPickerH}px`);
      scheduleCanvasResize();
    }
  }

  function scheduleBeadGridViewportSync() {
    syncBeadGridViewport();
    requestAnimationFrame(() => {
      syncBeadGridViewport();
      requestAnimationFrame(syncBeadGridViewport);
    });
    const imgs = els.grid?.querySelectorAll('.bd-bead-card__img img');
    if (!imgs?.length) return;
    let pending = 0;
    imgs.forEach((img) => {
      if (img.complete) return;
      pending += 1;
      const done = () => {
        pending -= 1;
        if (pending <= 0) syncBeadGridViewport();
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  function renderGrid() {
    if (!els.grid) return;
    const list = filteredCatalog();
    if (!list.length) {
      els.grid.innerHTML = '<p class="bd-empty-hint">No beads match your search.</p>';
      return;
    }

    const cards = list
      .map((b) => {
        const thumb = Core.resolveBeadThumbUrl(b);
        const img = thumb
          ? `<img src="${thumb}" alt="" width="56" height="56" loading="lazy" decoding="async" draggable="false">`
          : `<span class="bd-bead-card__sphere" style="background:${b.color || '#ccc'}"></span>`;
        const photos = getBeadActualPhotos(b);
        const photosBtn = photos.length
          ? `<button type="button" class="bd-bead-card__photos" data-bead-photos aria-label="${escapeHtml(actualPhotosUI?.viewLabel || 'View actual product photos')}">${CAMERA_ICON}</button>`
          : '';
        return `<div class="bd-bead-card" data-handle="${b.handle}">
          ${photosBtn}
          <button type="button" class="bd-bead-card__add">
            <div class="bd-bead-card__img">${img}</div>
            <div class="bd-bead-card__info">
              <p class="bd-bead-card__name">${escapeHtml(displayBeadName(b))}</p>
              <p class="bd-bead-card__meta">
                <span class="bd-bead-card__size">${b.diameter_mm}mm</span>
                <span class="bd-bead-card__price">${formatMoney(b.price)}</span>
              </p>
            </div>
          </button>
        </div>`;
      })
      .join('');

    els.grid.innerHTML = `<div class="bd-bead-grid">${cards}</div>`;
    els.grid.querySelectorAll('.bd-bead-card').forEach((card) => {
      card.querySelector('.bd-bead-card__add')?.addEventListener('click', () => addBead(card.dataset.handle, card));
      card.querySelector('[data-bead-photos]')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        actualPhotosUI?.openActualPhotosSheet(Core.resolveBead(card.dataset.handle));
      });
    });
    requestAnimationFrame(() => {
      scheduleBeadGridViewportSync();
    });
  }

  async function syncCanvas(animOpts = {}) {
    const prevCount = canvas?.beads?.length ?? 0;
    const adding = beads.length > prevCount;
    const circ = Core.calcCircumferenceCm(beads);
    canvas.setTargetCircumferenceCm(getTargetWristCm(circ));

    if (adding) {
      canvas.setBeads(beads, { animate: true, flyInFrom: animOpts.flyInFrom || null });
      pulseCanvas();
      canvas.preloadImages(beads).then(() => {
        if (!canvas.anim) canvas.draw();
      });
    } else {
      await canvas.preloadImages(beads);
      canvas.setBeads(beads, {
        animate: animOpts.animate !== false,
        onComplete: animOpts.onLand || null,
      });
      scheduleCanvasResize();
    }

    updateMeta();
    refreshInUseCategory();
    autoFitCanvasZoom();
  }

  function addBead(handle, sourceCard) {
    const meta = Core.resolveBead(handle);
    if (!meta) return;
    const circ = Core.calcCircumferenceCm(beads) + (Number(meta.diameter_mm) || 8) / 10;
    if (circ > maxCircumferenceCm()) {
      showLimitToast(`Cannot add more — ${WRIST_MAX_CM} cm maximum wrist size`);
      updateMeta();
      return;
    }
    beads.push({
      ...Core.beadWithRandomDisplayImage(meta),
      instanceId: `${handle}-${beads.length}-${Date.now()}`,
    });
    flashBeadCard(sourceCard);
    syncCanvas({ flyInFrom: beadCardToCanvas(sourceCard) });
    window.DesignerSounds?.playAdd?.();
  }

  function removeBead(index) {
    beads.splice(index, 1);
    canvas.selectedIndex = -1;
    syncCanvas();
    window.DesignerSounds?.playRemove?.();
  }

  function applyDesign(designJson, { title, wrist, titleMode = 'replace' } = {}) {
    const normalized = Core.normalizeDesignJson(designJson);
    const fromDesign =
      wrist ?? normalized?.wrist_size_cm ?? normalized?.w ?? designJson?.w ?? WRIST_DEFAULT_CM;
    wristSizeCm = clampWrist(fromDesign);
    beads = Core.expandDesign(designJson);
    if (els.title && titleMode !== 'keep') {
      if (titleMode === 'clone') {
        const base = title != null ? String(title) : '';
        const suffix = base.includes('(Clone)') ? '' : ' (Clone)';
        els.title.value = `${base}${suffix}`;
      } else if (titleMode === 'replace') {
        els.title.value = title != null ? String(title) : '';
      }
      els.title.dispatchEvent(new Event('input', { bubbles: true }));
    }
    syncCanvas();
    updateMeta();
  }

  function currentDesignCode() {
    if (!beads.length) return '';
    const circ = Core.calcCircumferenceCm(beads);
    const wristForCode = Core.roundWristCm(getCheckoutWristCm(circ));
    const title = (els.title?.value || '').trim() || 'My Crystal Bracelet';
    return Core.encodeDesignCode({
      title,
      wristSizeCm: wristForCode,
      beads,
    });
  }

  function openCodeImportModal(initialValue = '') {
    if (!codeImportEls?.root) return;
    if (codeImportEls.title) codeImportEls.title.textContent = i18n.codeModalTitle;
    if (codeImportEls.hint) codeImportEls.hint.textContent = i18n.codeModalHint;
    if (codeImportEls.confirm) codeImportEls.confirm.textContent = i18n.codeModalConfirm;
    if (codeImportEls.cancel) codeImportEls.cancel.textContent = i18n.codeModalCancel;
    if (codeImportEls.input) {
      codeImportEls.input.value = initialValue;
      codeImportEls.input.readOnly = false;
      codeImportEls.input.disabled = false;
    }
    codeImportEls.root.hidden = false;
    codeImportEls.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bd-code-import-open');
    requestAnimationFrame(() => {
      codeImportEls.root.classList.add('is-visible');
      window.setTimeout(() => {
        const input = codeImportEls.input;
        if (!input) return;
        input.focus({ preventScroll: true });
        if (initialValue) input.select();
      }, 280);
    });
  }

  function closeCodeImportModal() {
    if (!codeImportEls?.root) return;
    codeImportEls.root.classList.remove('is-visible');
    document.body.classList.remove('bd-code-import-open');
    window.setTimeout(() => {
      codeImportEls.root.hidden = true;
      codeImportEls.root.setAttribute('aria-hidden', 'true');
      if (codeImportEls.input) codeImportEls.input.value = '';
    }, 220);
  }

  function openToolsSheet() {
    if (!toolsSheetEls?.root) return;
    toolsSheetEls.root.hidden = false;
    toolsSheetEls.root.setAttribute('aria-hidden', 'false');
    els.addCart?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bd-tools-open');
    requestAnimationFrame(() => {
      toolsSheetEls.root.classList.add('is-visible');
    });
  }

  function closeToolsSheet() {
    if (!toolsSheetEls?.root) return;
    toolsSheetEls.root.classList.remove('is-visible');
    els.addCart?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bd-tools-open');
    window.setTimeout(() => {
      toolsSheetEls.root.hidden = true;
      toolsSheetEls.root.setAttribute('aria-hidden', 'true');
    }, 260);
  }

  function setupToolsSheet() {
    if (!toolsSheetEls?.root) return;

    els.addCart?.addEventListener('click', () => {
      if (toolsSheetEls.root.classList.contains('is-visible')) {
        closeToolsSheet();
      } else {
        openToolsSheet();
      }
    });

    toolsSheetEls.backdrop?.addEventListener('click', closeToolsSheet);
    toolsSheetEls.inspireBtn?.addEventListener('click', () => {
      closeToolsSheet();
      window.setTimeout(() => inspireDesign(), 120);
    });
    toolsSheetEls.importBtn?.addEventListener('click', () => {
      closeToolsSheet();
      window.setTimeout(() => openCodeImportModal(), 240);
    });
    toolsSheetEls.shareBtn?.addEventListener('click', () => {
      closeToolsSheet();
      window.setTimeout(() => openShareDesignModal(), 120);
    });

    document.addEventListener('keydown', (e) => {
      if (toolsSheetEls.root.hidden || !toolsSheetEls.root.classList.contains('is-visible')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeToolsSheet();
      }
    });
  }

  function openBeadPicker() {
    if (isMobilePicker()) {
      els.search?.blur();
      els.search?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      els.grid?.closest('.bd-bead-grid-wrap')?.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const grid = els.grid?.closest('.bd-picker-body') || els.grid;
    grid?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    els.search?.focus({ preventScroll: true });
  }

  function handleConfirmDesignClick() {
    const action = els.buyNow?.dataset.action || 'confirm-blocked';
    if (action === 'select-beads') {
      openBeadPicker();
      return;
    }
    confirmDesign();
  }

  function setupCodeImportModal() {
    if (!codeImportEls?.root) return;

    els.codeImportOpen?.addEventListener('click', () => openCodeImportModal());

    codeImportEls.backdrop?.addEventListener('click', closeCodeImportModal);
    codeImportEls.cancel?.addEventListener('click', closeCodeImportModal);
    codeImportEls.confirm?.addEventListener('click', async () => {
      const raw = codeImportEls.input?.value || '';
      const ok = await importDesignCode(raw, { fromModal: true });
      if (ok) closeCodeImportModal();
    });

    codeImportEls.input?.addEventListener('click', () => {
      codeImportEls.input?.focus({ preventScroll: true });
    });
    codeImportEls.input?.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeCodeImportModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (codeImportEls.root.hidden || !codeImportEls.root.classList.contains('is-visible')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeCodeImportModal();
      }
    });
  }

  async function openShareDesignModal() {
    if (!beads.length) {
      showToast(i18n.codeCopyEmpty, { type: 'error' });
      return;
    }
    const circ = Core.calcCircumferenceCm(beads);
    const wristForCode = Core.roundWristCm(getCheckoutWristCm(circ));
    const title = (els.title?.value || '').trim() || 'My Crystal Bracelet';
    await window.DesignShare?.openShare(
      {
        title,
        wristSizeCm: wristForCode,
        beads,
        designJson: Core.compactDesignJson(beads, wristForCode),
        beadCount: beads.length,
        price: Core.calcTotal(beads),
      },
      { showToast }
    );
  }

  async function copyDesignCode() {
    const code = currentDesignCode();
    if (!code) {
      showToast(i18n.codeCopyEmpty, { type: 'error' });
      return;
    }
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const helper = document.createElement('textarea');
        helper.value = code;
        helper.setAttribute('readonly', '');
        helper.style.position = 'fixed';
        helper.style.left = '-9999px';
        document.body.appendChild(helper);
        helper.select();
        document.execCommand('copy');
        document.body.removeChild(helper);
      }
      showToast(i18n.codeCopied, { type: 'success' });
    } catch {
      showToast(i18n.codeCopied, { type: 'success' });
    }
  }

  async function importDesignCode(rawCode, opts = {}) {
    let parsed = Core.parseDesignCode(rawCode);
    if (!parsed?.designJson && window.DesignShare?.resolveShareInput) {
      try {
        parsed = await window.DesignShare.resolveShareInput(rawCode);
      } catch {
        parsed = null;
      }
    }
    if (!parsed?.designJson) {
      if (!opts.silent) showToast(i18n.codeInvalid, { type: 'error' });
      return false;
    }

    if (beads.length > 0 && !opts.skipConfirm && !opts.fromModal) {
      const ok = await showConfirmDialog({
        title: i18n.codeReplaceTitle,
        message: i18n.codeReplaceMessage,
        confirmText: i18n.codeReplaceConfirm,
        cancelText: 'Cancel',
        variant: 'inspire',
      });
      if (!ok) return false;
    }

    activeSavedDesignId = null;
    applyDesign(parsed.designJson, {
      title: parsed.title || undefined,
      wrist: parsed.designJson?.w ?? parsed.designJson?.wrist_size_cm,
      titleMode: parsed.title ? 'replace' : 'keep',
    });
    pulseCanvas();
    if (!opts.silent) showToast(i18n.codeImported, { type: 'success' });
    return true;
  }

  function loadFromConfirmStorage() {
    const payload = Core.getDesignConfirm();
    if (!payload?.designJson) return false;
    const id = payload.designId ? String(payload.designId) : '';
    activeSavedDesignId = id && !id.startsWith('custom-') ? id : null;
    applyDesign(payload.designJson, {
      title: typeof payload.title === 'string' ? payload.title : undefined,
      wrist: payload.wristSizeCm,
      titleMode: 'replace',
    });
    return beads.length > 0;
  }

  function loadFromCloneStorage() {
    const payload = Core.consumeDesignClone();
    if (!payload?.designJson) return false;
    activeSavedDesignId = null;
    applyDesign(payload.designJson, {
      title: payload.title,
      wrist: payload.wristSizeCm,
      titleMode: 'clone',
    });
    return beads.length > 0;
  }

  async function loadSavedDesign(designId) {
    const Cloud = window.DesignCloudApi;
    await Core.ensureCustomerContext();

    if (Cloud?.enabled() && Core.isLoggedInCustomer()) {
      try {
        const saved = await Cloud.getByHandle(designId);
        if (!saved?.designJson) return false;
        activeSavedDesignId = saved.handle || saved.id;
        applyDesign(saved.designJson, {
          title: saved.title,
          wrist: saved.wristSizeCm,
          titleMode: 'replace',
        });
        return beads.length > 0;
      } catch {
        return false;
      }
    }

    await Core.mergeGuestMyDesignsIfNeeded();
    const saved = Core.getMyDesign(designId);
    if (!saved?.designJson) return false;
    activeSavedDesignId = saved.id;
    applyDesign(saved.designJson, {
      title: saved.title,
      wrist: saved.wristSizeCm,
      titleMode: 'replace',
    });
    return beads.length > 0;
  }

  function syncDesignQueryParam() {
    if (!activeSavedDesignId || typeof history.replaceState !== 'function') return;
    const url = new URL(window.location.href);
    url.searchParams.set('design', activeSavedDesignId);
    history.replaceState({}, '', url);
  }

  function loginUrlForReturn() {
    const returnPath = `${window.location.pathname}${window.location.search}`;
    const cfg = Core.CONFIG();
    if (cfg.storefrontLoginUrl) {
      const sep = cfg.storefrontLoginUrl.includes('?') ? '&' : '?';
      return `${cfg.storefrontLoginUrl}${sep}return_to=${encodeURIComponent(returnPath)}`;
    }
    return `/customer_authentication/login?return_to=${encodeURIComponent(returnPath)}`;
  }

  async function saveToMyDesigns() {
    if (els.save?.classList.contains('is-loading')) return;

    if (!beads.length) {
      showToast(i18n.saveEmpty, { type: 'error' });
      return;
    }

    const Cloud = window.DesignCloudApi;
    if (Cloud?.enabled()) {
      await Core.ensureCustomerContext();
      if (!Core.isLoggedInCustomer()) {
        redirectToLoginForSave();
        return;
      }
    }

    const circ = Core.calcCircumferenceCm(beads);
    const wristForSave = Core.roundWristCm(getCheckoutWristCm(circ));
    const title = (els.title?.value || '').trim() || 'My Crystal Bracelet';
    const designJson = Core.compactDesignJson(beads, wristForSave);
    const beadCount = beads.length;
    const price = Core.calcTotal(beads);

    setSaveLoading(true);
    try {
      await Core.ensureCustomerContext();
      let usedLocalFallback = false;

      if (Cloud?.enabled()) {
        try {
          const saved = await Cloud.save({
            handle: activeSavedDesignId || undefined,
            title,
            wristSizeCm: wristForSave,
            designJson,
            beadCount,
            price,
          });
          activeSavedDesignId = saved.handle || saved.id;
        } catch (cloudErr) {
          if (Cloud.isCloudUnavailableError?.(cloudErr)) {
            await Core.mergeGuestMyDesignsIfNeeded();
            const saved = Core.saveMyDesign({
              id: activeSavedDesignId || undefined,
              title,
              wristSizeCm: wristForSave,
              designJson,
            });
            activeSavedDesignId = saved.id;
            usedLocalFallback = true;
          } else {
            throw cloudErr;
          }
        }
      } else {
        await Core.mergeGuestMyDesignsIfNeeded();
        const saved = Core.saveMyDesign({
          id: activeSavedDesignId || undefined,
          title,
          wristSizeCm: wristForSave,
          designJson,
        });
        activeSavedDesignId = saved.id;
      }

      syncDesignQueryParam();
      commitDesignBaseline();
      if (usedLocalFallback) {
        showToast(i18n.saveLocalFallback, { type: 'error' });
      } else {
        showToast(i18n.saveSuccess, { type: 'success' });
      }
    } catch (err) {
      if (err?.message === 'LOGIN_REQUIRED') {
        showToast(i18n.saveLoginRequired, { type: 'error' });
        return;
      }
      showToast(i18n.saveError, { type: 'error' });
    } finally {
      setSaveLoading(false);
    }
  }

  function loadTemplate(handle) {
    let tpl = Core.getTemplateByHandle(handle);
    if (!tpl?.design_json || Core.expandDesign(tpl.design_json).length === 0) {
      const resolved = Core.resolveDesignTemplate(handle);
      tpl = resolved.tpl;
    }
    if (!tpl?.design_json) return;
    activeSavedDesignId = null;
    applyDesign(tpl.design_json, {
      title: tpl.title,
      wrist: tpl.design_json?.wrist_size_cm ?? tpl.design_json?.w ?? tpl.wrist_size_cm,
      titleMode: 'replace',
    });
  }

  async function inspireDesign() {
    if (beads.length > 0) {
      const ok = await showConfirmDialog({
        title: 'Replace design?',
        message: 'Your current bracelet will be replaced with a new inspiration. You can keep editing afterward.',
        confirmText: 'Inspire',
        cancelText: 'Keep current',
        variant: 'inspire',
      });
      if (!ok) return;
    }

    const tpl = Core.pickRandomInspireTemplate(lastInspireHandle);
    if (!tpl?.design_json) {
      showToast('No inspiration templates available', { type: 'error' });
      return;
    }

    lastInspireHandle = tpl.handle || null;
    activeSavedDesignId = null;
    applyDesign(tpl.design_json, {
      title: tpl.title || 'My Crystal Bracelet',
      wrist: tpl.design_json?.wrist_size_cm ?? tpl.design_json?.w ?? tpl.wrist_size_cm,
      titleMode: 'replace',
    });
    pulseCanvas();
    showToast(`Inspired: ${tpl.title || 'Custom design'}`, { type: 'success' });
  }

  async function confirmDesign() {
    const circ = Core.calcCircumferenceCm(beads);
    const target = getTargetWristCm(circ);
    const fitPct = target > 0 ? Math.round((circ / target) * 100) : 0;
    const blockers = getCheckoutBlockers(fitPct);
    if (blockers.length) {
      await showConfirmDialog({
        title: 'Cannot confirm design yet',
        message: blockers[0],
        confirmText: 'OK',
        mode: 'alert',
      });
      return;
    }

    const title = els.title?.value?.trim() || 'My Crystal Bracelet';
    const wristForCart = Core.roundWristCm(getCheckoutWristCm(circ));
    const confirmDesignId =
      activeSavedDesignId || `custom-${Date.now()}`;
    Core.saveDesignConfirm({
      title,
      wristSizeCm: wristForCart,
      beads,
      designJson: Core.compactDesignJson(beads, wristForCart),
      designId: confirmDesignId,
      createdAt: activeSavedDesignId ? undefined : new Date().toISOString(),
    });

    exitBypass = true;
    const base = cfg.designDetailUrl || '/?view=design-detail';
    const sep = base.includes('?') ? '&' : '?';
    window.location.href = `${base}${sep}custom=1`;
  }

  function delay(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function createPreparingUI() {
    const overlay = document.querySelector('[data-bd-preparing]');
    const pct = overlay?.querySelector('[data-bd-preparing-pct]');
    const bar = overlay?.querySelector('[data-bd-preparing-bar]');
    const status = overlay?.querySelector('[data-bd-preparing-status]');
    const tipTitle = overlay?.querySelector('[data-bd-preparing-tip-title]');
    const tipBody = overlay?.querySelector('[data-bd-preparing-tip-body]');
    let tipIdx = 0;
    let tipTimer = null;

    function setTip(i) {
      const tip = PREPARING_TIPS[i % PREPARING_TIPS.length];
      if (tipTitle) tipTitle.textContent = tip.title;
      if (tipBody) tipBody.textContent = tip.body;
    }

    return {
      show() {
        if (!overlay) return;
        overlay.classList.remove('bd-preparing--done');
        overlay.setAttribute('aria-busy', 'true');
        setTip(0);
        tipTimer = window.setInterval(() => {
          tipIdx += 1;
          setTip(tipIdx);
        }, 2800);
      },
      setProgress(done, total) {
        const t = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 100;
        if (pct) pct.textContent = `${t}%`;
        if (bar) bar.style.width = `${t}%`;
        if (status) {
          status.textContent =
            t >= 100 ? 'Almost ready…' : `Loading catalog… (${done}/${total})`;
        }
      },
      hide() {
        if (tipTimer) {
          clearInterval(tipTimer);
          tipTimer = null;
        }
        if (pct) pct.textContent = '100%';
        if (bar) bar.style.width = '100%';
        if (status) status.textContent = 'Opening studio…';
        root.classList.remove('bd-root--preparing');
        if (!overlay) return;
        overlay.classList.add('bd-preparing--done');
        overlay.setAttribute('aria-busy', 'false');
        window.setTimeout(() => overlay.remove(), 400);
      },
    };
  }

  async function warmCatalogThumbs(imageCache, preparing) {
    const urls = Core.catalogThumbUrls();
    if (!urls.length) {
      preparing.setProgress(1, 1);
      return;
    }
    preparing.setProgress(0, urls.length);
    const preload = Core.preloadBeadImages(urls, {
      concurrency: PREP_CONCURRENCY,
      imageCache,
      onProgress: (done, total) => preparing.setProgress(done, total),
    });
    await Promise.race([preload, delay(PREP_THUMB_MAX_MS)]);
  }

  function warmCatalogCanvasImages(imageCache) {
    const urls = Core.catalogCanvasImageUrls();
    if (!urls.length) return;
    void Core.preloadBeadImages(urls, {
      concurrency: PREP_CONCURRENCY,
      imageCache,
    }).then(() => {
      if (canvas && !canvas.anim) canvas.draw();
    });
  }

  async function loadInitialDesign(params, { loadedEdit, loadedClone }) {
    if (loadedEdit || loadedClone) {
      void Core.ensureCustomerContext().then(() => {
        Core.mergeGuestMyDesignsIfNeeded();
        updateSaveButtonAuthState();
      });
      return;
    }

    const savedDesignId = params.get('design');
    const Cloud = window.DesignCloudApi;

    await Core.ensureCustomerContext();
    Core.debugAuth?.('Design Studio');
    updateSaveButtonAuthState();

    const loadingFromCloud = !!(
      savedDesignId &&
      Cloud?.enabled() &&
      Core.isLoggedInCustomer()
    );

    if (loadingFromCloud) setDesignLoading(true);
    try {
      await Core.mergeGuestMyDesignsIfNeeded();

      if (savedDesignId && (await loadSavedDesign(savedDesignId))) return;

      const sharedCode = params.get('code');
      if (sharedCode) {
        await importDesignCode(sharedCode, { skipConfirm: true, silent: true });
        return;
      }

      const templateHandle = params.get('template');
      if (templateHandle) loadTemplate(templateHandle);
    } finally {
      if (loadingFromCloud) setDesignLoading(false);
    }
  }

  function setupImageTouchGuard() {
    const blockImageDefault = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.tagName === 'IMG' || t.closest('.bd-bead-card, .bd-sidebar, [data-bd-canvas-wrap]')) {
        e.preventDefault();
      }
    };
    root.addEventListener('contextmenu', blockImageDefault, { capture: true });
    root.addEventListener('dragstart', blockImageDefault, { capture: true });
    root.addEventListener(
      'selectstart',
      (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest('input:not([readonly]), textarea')) return;
        e.preventDefault();
      },
      { capture: true }
    );
  }

  async function init() {
    const preparing = createPreparingUI();
    preparing.show();

    canvas = new Core.BraceletCanvas(els.canvas);
    applyMobileCanvasProfile();
    MOBILE_PICKER_MQ.addEventListener('change', applyMobileCanvasProfile);
    await setupCenterLogo();

    if (window.__beadCatalogReadyPromise) {
      try {
        await window.__beadCatalogReadyPromise;
      } catch (err) {
        console.warn('[BeadCatalog] full catalog load failed, using embedded page', err);
      }
    }

    if (window.DesignerSounds && window.__DESIGNER_SOUND_URLS__) {
      window.DesignerSounds.init(window.__DESIGNER_SOUND_URLS__);
    }

    await Promise.all([warmCatalogThumbs(canvas.imageCache, preparing), delay(PREP_MIN_MS)]);
    preparing.hide();
    warmCatalogCanvasImages(canvas.imageCache);

    const params = new URLSearchParams(window.location.search);
    const wantsEdit = params.get('edit') === '1';
    const wantsClone = params.get('clone') === '1';
    const loadedEdit = wantsEdit && loadFromConfirmStorage();
    const loadedClone = !loadedEdit && wantsClone && loadFromCloneStorage();

    renderCategories();
    renderGrid();

    void Core.ensureCustomerContext().then(() => updateSaveButtonAuthState());

    const designLoadPromise = loadInitialDesign(params, { loadedEdit, loadedClone });

    await setupCenterLogo();
    updateMeta();
    renderPickerToggleButton();

    const resizeObs = new ResizeObserver(() => {
      canvas.resize();
      autoFitCanvasZoom();
    });
    if (els.canvas?.parentElement) resizeObs.observe(els.canvas.parentElement);
    canvas.resize();
    autoFitCanvasZoom();
    setupCanvasInteraction();
    setupImageTouchGuard();
    setupPickerResize();
    setupCodeImportModal();
    setupToolsSheet();
    setupDesignerNav();
    setupTitleEditor();
    window.addEventListener('resize', scheduleBeadGridViewportSync);

    document.addEventListener('bead-catalog:ready', () => {
      renderGrid();
    });

    els.search?.addEventListener('input', (e) => {
      searchQuery = e.target.value;
      renderGrid();
    });

    els.clear?.addEventListener('click', async () => {
      if (beads.length) {
        const ok = await showConfirmDialog({
          title: 'Clear bracelet?',
          message: 'Remove all beads from the canvas?',
          confirmText: 'Clear all',
          cancelText: 'Cancel',
          variant: 'danger',
        });
        if (!ok) return;
      }
      beads = [];
      activeSavedDesignId = null;
      syncCanvas();
    });

    els.inspire?.addEventListener('click', inspireDesign);
    els.save?.addEventListener('click', handleSaveClick);

    els.codeCopyBtn?.addEventListener('click', copyDesignCode);

    root.querySelector('[data-bd-zoom-in]')?.addEventListener('click', () => {
      applyZoom(zoom + 0.1);
    });

    root.querySelector('[data-bd-zoom-out]')?.addEventListener('click', () => {
      applyZoom(zoom - 0.1);
    });

    els.buyNow?.addEventListener('click', handleConfirmDesignClick);

    if (els.picker) {
      els.picker.setAttribute('aria-hidden', 'false');
    }

    MOBILE_PICKER_MQ.addEventListener('change', () => {
      applyMobileCanvasProfile();
      scheduleBeadGridViewportSync();
      scheduleCanvasResize();
    });

    await designLoadPromise;
    updateSaveButtonAuthState();
    commitDesignBaseline();
    setupExitGuard();
    scheduleBeadGridViewportSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
